import type { OrgPermission } from '$shared/constants/OrgPermission';

type Access = {
  view: boolean;
};

class AppPermissionData {
  private permission: Record<OrgPermission, Access> = {} as Record<OrgPermission, Access>;

  public setViewAccess(key: OrgPermission, hasAccess: boolean): void {
    this.permission[key] = { view: !!hasAccess };
  }

  public hasViewAccess(key: OrgPermission) {
    return !!this.permission[key]?.view;
  }

  public reset(): void {
    this.permission = {} as Record<OrgPermission, Access>;
  }
}

export const appPermissionData = new AppPermissionData();
